export default {
  root: {
    width: '2.5rem',
    height: '1.5rem',
    borderRadius: '30px',
    gap: '0.25rem',
    shadow: '{form.field.shadow}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    borderWidth: '1px',
    borderColor: 'transparent',
    hoverBorderColor: 'transparent',
    checkedBorderColor: 'transparent',
    checkedHoverBorderColor: 'transparent',
    invalidBorderColor: '{form.field.invalid.border.color}',
    transitionDuration: '{form.field.transition.duration}',
    slideDuration: '0.2s',
    disabledBackground: '{form.field.disabled.background}',
  },
  handle: {
    background: '#ffffff',
    borderRadius: '50%',
    size: '1rem',
    disabledBackground: '{form.field.disabled.color}',
  },
  colorScheme: {
    light: {
      root: {
        background: '{surface.300}',
        hoverBackground: '{surface.400}',
        checkedBackground: '{teal.500}',
        checkedHoverBackground: '{teal.500}',
      },
      handle: {
        background: '#ffffff',
        hoverBackground: '#ffffff',
        checkedBackground: '#ffffff',
        checkedHoverBackground: '#ffffff',
      },
    },
    dark: {
      root: {
        background: '{surface.700}',
        hoverBackground: '{surface.600}',
        checkedBackground: '{teal.500}',
        checkedHoverBackground: '{teal.500}',
      },
      handle: {
        background: '#ffffff',
        hoverBackground: '#ffffff',
        checkedBackground: '#ffffff',
        checkedHoverBackground: '#ffffff',
      },
    },
  },
};
